import React, { useState } from 'react';

import BasicCRUD from './../core/basic-crud';
import FadeAlert from "../core/fade-alert";

const StatusPage = (props) => {
    const object = "status_pages";
    const [response, setResponse] = useState({});
    const [fieldsData, setFieldsData] = useState({});

    const columns = [
        { label: "ID", key: "id" },
        { label: "Name", key: "name" },
        { label: "Created", key: "date_created" },
    ];

    const fields = [
        {
            type: "tab",
            name: "Main",
            image: "",
            fields: [
                [{ label: "Logo", key: "logo", default_value: "", showLabel: "top", type: "file" }],
                [{ label: "Name", key: "name", default_value: "", showLabel: "top" }],
                [{ label: "Alias", key: "alias", default_value: "", showLabel: "top" }],
                /*
                [{ label: "Date Created", key: "date_created", default_value: "", showLabel: "top" }],
                [{ label: "Company ID", key: "company_id", default_value: "", showLabel: "top" }],

                [{ label: "Last Incident", key: "last_incident", default_value: "", showLabel: "top" }],

                [{ label: "Page", key: "page", default_value: "", showLabel: "top" }],
                [{ label: "Cropped Logo", key: "cropped_logo", default_value: "", showLabel: "top" }],
                [{ label: "Second Page", key: "second_page", default_value: "", showLabel: "top" }],
                 */
            ],
        },
    ];

    const actions = [
        { name: "edit", label: "Edit", controller: "crud" },
        { name: "delete", label: "Delete", controller: "crud" },
    ];

    let filters = { active: true };

    return (
        <>
            <BasicCRUD
                title={"Status Pages"}
                subTitle={"Manage status pages"}
                homeURL={"/dashboard"}
                addTitle="Add Status Page" editTitle={"Edit Status Page"}
                object={object} columns={columns} fields={fields} actions={actions}
                fieldsData={fieldsData} setFieldsData={setFieldsData}
                response={response} setResponse={setResponse}
                ownHandler={true}
                deleteConfirmationDialog={{
                    alert: 'Deleting a status page cannot be undone.',
                    text: 'To confirm deletion, enter the name of the status page in the next input field',
                    title: 'Delete Status Page: "{name}"',
                    column: 'name',
                }}
            >
                {response.status && response.status === 1 ? (
                    <>
                        <FadeAlert response={response} resetResponse={() => setResponse([])}>
                            {response.created && response.created === 1 ? (
                                <>
                                    <strong>Status Page</strong> created successfully
                                </>
                            ) : null}
                            {response.updated && response.updated === 1 ? (
                                <>
                                    <strong>Status Page</strong> updated successfully
                                </>
                            ) : null}
                            {response.delete && response.delete === 1 ? (
                                <>
                                    <strong>Status Page</strong> deleted successfully
                                </>
                            ) : null}
                        </FadeAlert>
                    </>
                ) : null}
            </BasicCRUD>
        </>
    );
};

export default StatusPage;
